(function () {
  if (customElements.get('cart-recommendations')) return;

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.maxProducts = parseInt(this.dataset.maxProducts || '4', 10);
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      this.list = this.querySelector('[data-cart-recommendations-list]');
      this.load();

      // Refresh when the cart changes (Dawn publishes cart-update events).
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.load());
        }
      } catch (e) {
        /* pubsub unavailable */
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
    }

    async load() {
      try {
        const cart = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js').then((r) => r.json());
        if (!cart.items || cart.items.length === 0) {
          this.hidden = true;
          return;
        }

        const cartProductIds = new Set(cart.items.map((item) => item.product_id));
        const seedIds = Array.from(cartProductIds).slice(0, 2);
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        const responses = await Promise.all(
          seedIds.map((id) =>
            fetch(`${root}recommendations/products.json?product_id=${id}&limit=${this.maxProducts + 4}&intent=related`)
              .then((r) => (r.ok ? r.json() : { products: [] }))
              .catch(() => ({ products: [] }))
          )
        );

        const seen = new Set();
        const products = [];
        responses.forEach((response) => {
          (response.products || []).forEach((product) => {
            if (cartProductIds.has(product.id) || seen.has(product.id)) return;
            seen.add(product.id);
            products.push(product);
          });
        });

        const picks = products.slice(0, this.maxProducts);
        if (picks.length === 0) {
          this.hidden = true;
          return;
        }

        this.render(picks);
        this.hidden = false;
      } catch (e) {
        this.hidden = true;
      }
    }

    render(products) {
      if (!this.list) return;
      this.list.innerHTML = products
        .map((product) => {
          const image = product.featured_image
            ? `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=360`
            : '';
          const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
          const compareAt = hasDiscount
            ? `<s class="cart-recs__price-compare">${this.formatMoney(product.compare_at_price)}</s>`
            : '';
          const discountBadge = hasDiscount
            ? `<span class="cart-recs__badge">${Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100)}% off</span>`
            : '';
          const priceClass = compareAt ? ' cart-recs__price--sale' : '';
          const singleVariant = product.variants && product.variants.length === 1 && product.variants[0].available;
          const action = singleVariant
            ? `<button type="button" class="cart-recs__add button button--secondary" data-variant-id="${product.variants[0].id}">${this.dataset.addLabel || 'Add'}</button>`
            : `<a href="${product.url}" class="cart-recs__add button button--secondary">${this.dataset.viewLabel || 'View'}</a>`;

          return `
            <li class="cart-recs__item">
              <a href="${product.url}" class="cart-recs__media" tabindex="-1" aria-hidden="true">
                ${image ? `<img src="${image}" alt="" loading="lazy" width="180" height="270">` : ''}
                ${discountBadge}
              </a>
              <div class="cart-recs__info">
                <a href="${product.url}" class="cart-recs__title">${this.escape(product.title)}</a>
                <span class="cart-recs__price${priceClass}">${compareAt} ${this.formatMoney(product.price)}</span>
                ${action}
              </div>
            </li>`;
        })
        .join('');

      this.list.querySelectorAll('button[data-variant-id]').forEach((button) => {
        button.addEventListener('click', () => this.addToCart(button));
      });
    }

    escape(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    async addToCart(button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const body = { items: [{ id: parseInt(button.dataset.variantId, 10), quantity: 1 }] };
        const cartDrawer = document.querySelector('cart-drawer');
        const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        if (cartItems && cartItems.getSectionsToRender) {
          body.sections = cartItems.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (cartItems && data.sections && cartItems.getSectionsToRender) {
          cartItems.getSectionsToRender().forEach((section) => {
            const element = document.getElementById(section.id);
            if (!element || !data.sections[section.id]) return;
            const target = section.selector ? element.querySelector(section.selector) : element;
            if (!target) return;
            const html = new DOMParser().parseFromString(data.sections[section.id], 'text/html');
            const source = section.selector ? html.querySelector(section.selector) : html.body.firstElementChild;
            if (source) target.innerHTML = source.innerHTML;
          });
        } else {
          window.location.reload();
          return;
        }
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        this.load();
      } catch (e) {
        window.location.reload();
      } finally {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
})();
